import { useEffect, useRef } from "react"
import { apiClient } from "@/lib/api"

/** Session-level dedup — prevents duplicate POSTs within the same browser session. */
const firedThisSession = new Set<string>()

/**
 * Fire-and-forget activation event for onboarding checklist.
 * Call once per page component (e.g. `useActivationEvent(propertyId, "overview_viewed")`).
 */
export function useActivationEvent(propertyId: string | undefined, eventKey: string) {
  const hasFired = useRef(false)

  useEffect(() => {
    if (!propertyId || hasFired.current) return

    const cacheKey = `${propertyId}:${eventKey}`
    if (firedThisSession.has(cacheKey)) return

    hasFired.current = true
    firedThisSession.add(cacheKey)

    apiClient.recordActivationEvent(propertyId, eventKey).catch(() => {
      // Silent failure — activation tracking is non-critical
      firedThisSession.delete(cacheKey)
      hasFired.current = false
    })
  }, [propertyId, eventKey])
}
